module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/366.a69bb178.png";